import { useMemo } from 'react';

import { useGetWorkoutPlan } from 'hooks/workout/useGetWorkoutPlan';

import { getIsWorkoutDone, getSortedPlan } from './helpers';

const useGetFormattedWorkoutPlan = () => {
    const { plan, ...rest } = useGetWorkoutPlan();

    const formattedWorkoutPlan = useMemo(
        () =>
            getSortedPlan(plan).map((plan) => ({ ...plan, done: getIsWorkoutDone(plan.category, plan.completion_id) })),
        [plan]
    );

    return { plan: formattedWorkoutPlan, ...rest };
};

export default useGetFormattedWorkoutPlan;
